import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';
import { searchHeatPumpByText } from '../../redux/heat_pump/heat_pump_actions';

import {
  listHeatPumpInBuilding,
  addHeatPumpToBuilding,
  editHeatPumpInBuilding,
  removeHeatPumpFromBuilding,
} from '../../redux/projects/project_heat_pump_actions';
import { getProject } from '../../redux/projects/projects_actions';


export class HeatPumpDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'heat_pump.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'heat_pump.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchHeatPumpByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        id: 'heat-pump-cop',
        Header: () => <b>{t('COP')}</b>,
        accessor: 'heat_pump.COP',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        width: 80,
        ...decimalColumn,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {};
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.listHeatPump(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      buildingId,
      filtered,
      filteredCount,
      isHeatPumpLoading,
      addHeatPump,
      editHeatPump,
      removeHeatPump,
      isHeatPumpAdding,
      isHeatPumpEditing,
      isHeatPumpRemoving,
      errorMessage,
    } = this.props;

    const relationship = {
      create: ({ entityId, quantity }) => addHeatPump(entityId, buildingId, quantity),
      edit: ({ id, quantity }) => editHeatPump(id, quantity),
      delete: id => removeHeatPump(id, buildingId),
      isCreating: isHeatPumpAdding,
      isEditing: isHeatPumpEditing,
      isDeleting: isHeatPumpRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={this.columns}
          data={this.props.relationships}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.heat_pump.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isHeatPumpLoading}
          onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  relationships: state.projectHeatPump.orderedIds.map(id => state.projectHeatPump.objects[id]),
  filteredCount: state.projectHeatPump.filteredCount,
  isHeatPumpLoading: state.projectHeatPump.isLoading,
  isHeatPumpAdding: state.projectHeatPump.isCreating,
  isHeatPumpEditing: state.projectHeatPump.isEditing,
  isHeatPumpRemoving: state.projectHeatPump.isDeleting,
  errorMessage: state.projectHeatPump.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listHeatPump: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listHeatPumpInBuilding(pageSize, page, sorted, filtered, isPublic, props.buildingId))),
  addHeatPump: (heatPumpId, buildingId, quantity) =>
    defaultRejectHandler(dispatch(addHeatPumpToBuilding(heatPumpId, buildingId, quantity))
      .then(() => dispatch(getProject(props.projectId)))),
  editHeatPump: (buildingHeatPumpId, quantity) =>
    defaultRejectHandler(dispatch(editHeatPumpInBuilding(buildingHeatPumpId, quantity))),
  removeHeatPump: (buildingHeatPumpId, buildingId) =>
    defaultRejectHandler(dispatch(removeHeatPumpFromBuilding(buildingHeatPumpId, buildingId))
      .then(() => dispatch(getProject(props.projectId)))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(HeatPumpDataTable),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/HeatPumpDataTable.js